export default __webpack_public_path__ + "static/SecondImageBlue-58484876aebbf1e2a3e3573c43a7add4.png";